/**
 * Tab keys for permission-based access. Must match backend account.permissions.TAB_KEYS.
 * Each key maps to a sidebar item; super admin has all, others only see selected tabs.
 */
export const TAB_KEYS = [
  "dashboard",
  "shops",
  "users",
  "employees",
  "customers",
  "suppliers",
  "category",
  "units",
  "products",
  "stock",
  "purchases",
  "sales",
  "sale_return",
  "purchase_return",
  "purchase_payments",
  "sales_payments",
  "currencies",
  "exchange_rates",
  "accounts",
  "payroll",
  "advance",
  "expenses",
  "incomes",
  "expense_categories",
  "reports",
];

/** Path to tab key mapping for route guard */
export const PATH_TO_TAB = {
  "/shop/dashboard": "dashboard",
  "/shop/shop": "shops",
  "/shop/users": "users",
  "/shop/employees": "employees",
  "/shop/customers": "customers",
  "/shop/suppliers": "suppliers",
  "/shop/category": "category",
  "/shop/units": "units",
  "/shop/products": "products",
  "/shop/stock": "stock",
  "/shop/purchases": "purchases",
  "/shop/sales": "sales",
  "/shop/sale-return": "sale_return",
  "/shop/purchase-return": "purchase_return",
  "/shop/purchase-payments": "purchase_payments",
  "/shop/sales-payments": "sales_payments",
  "/shop/currencies": "currencies",
  "/shop/exchange-rates": "exchange_rates",
  "/shop/accounts": "accounts",
  "/shop/account-transactions": "accounts",
  "/shop/account-transfers": "accounts",
  "/shop/payroll": "payroll",
  "/shop/advance": "advance",
  "/shop/expenses": "expenses",
  "/shop/incomes": "incomes",
  "/shop/expense-categories": "expense_categories",
  "/shop/report-index": "reports",
};

export function pathToTabKey(pathname) {
  const normalized = pathname.replace(/\/$/, "") || "/shop/dashboard";
  return PATH_TO_TAB[normalized] ?? PATH_TO_TAB[normalized + "/"] ?? null;
}

export function hasTabAccess(user, tabKey) {
  if (!user) return false;
  if (user.is_superuser) return true;
  const allowed = user.allowed_tabs || [];
  return Array.isArray(allowed) && allowed.includes(tabKey);
}

export function canAccessPath(user, pathname) {
  const tabKey = pathToTabKey(pathname);
  if (!tabKey) return true;
  return hasTabAccess(user, tabKey);
}

/** Translation key for each tab (use with t('sidebar.xxx')) */
export const TAB_KEY_TO_LABEL = {
  dashboard: "sidebar.dashboard",
  shops: "sidebar.shops",
  users: "sidebar.users",
  employees: "sidebar.employees",
  customers: "sidebar.customers",
  suppliers: "sidebar.suppliers",
  category: "sidebar.categories",
  units: "sidebar.units",
  products: "sidebar.products",
  stock: "sidebar.stock",
  purchases: "sidebar.purchases",
  sales: "sidebar.sales",
  sale_return: "sidebar.saleReturn",
  purchase_return: "sidebar.purchaseReturn",
  purchase_payments: "sidebar.purchasePayments",
  sales_payments: "sidebar.salesPayments",
  currencies: "sidebar.currencies",
  exchange_rates: "sidebar.exchangeRates",
  accounts: "sidebar.accounts",
  account_transactions: "sidebar.accountTransactions",
  payroll: "sidebar.payroll",
  advance: "sidebar.advance",
  expenses: "sidebar.expenses",
  incomes: "sidebar.incomes",
  expense_categories: "sidebar.expenseCategories",
  reports: "sidebar.reports",
};
